import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "table__before__stats",
  style: {"padding":"10px 0","justify-content":"center","flex-wrap":"wrap"}
}
const _hoisted_2 = { class: "table__before__stats--selected" }

import { ref } from 'vue';
import {
  XrkTable,
  XrkTableProps,
  useTableColumn,
  BaseDialog,
  BaseTextContent,
  BaseButton
} from 'xrk-components';
import { formatter } from '@/utils';
import { queryInvoiceOrder } from '@V/invoice/src/data-source/apis';
import { STATE_TYPE } from '@constants/order';
import { useJumpToOrderDetail } from '@hooks/order';


export default /*#__PURE__*/_defineComponent({
  __name: 'invoice-price-tax-dialog',
  props: {
    remove: {},
    invoiceApplyId: {},
    invoiceBusinessType: {}
  },
  setup(__props: any) {

const props = __props;

const xrkTableRef = ref();
const invoiceAmount = ref(0);

const getListAjax = async params => {
  const resp = await queryInvoiceOrder({ ...params, ...props });
  invoiceAmount.value = resp.data.invoiceAmount;
  return resp;
};

const searchConfig = ref<XrkTableProps['searchConfig']>({
  searchColumns: [],
  searchBtn: { show: false },
  resetBtn: { show: false }
});

const tableConfig = ref<XrkTableProps['tableConfig']>({
  tableColumns: [
    useTableColumn({
      type: 'index',
      label: '序号',
      width: '80px',
      fixed: 'left'
    }),
    useTableColumn({
      label: '对应订单编号',
      prop: 'orderNo',
      width: '240px'
    }),
    useTableColumn({
      label: '订单类型',
      prop: 'orderType',
      width: '180px',
      formatter: ({ cellValue }) =>
        formatter.defaultFormat(cellValue, () => STATE_TYPE[cellValue].label)
    }),

    useTableColumn({
      label: '订单金额(元)',
      prop: 'orderAmount',
      width: '180px',
      render({ row, cellValue }) {
        return (
          <BaseButton
            link
            onClick={() => {
              useJumpToOrderDetail(row.orderNo, { method: 'open' });
            }}
          >
            {formatter.fen2yuan(cellValue)}
          </BaseButton>
        );
      }
    }),
    useTableColumn({
      label: '收款时间',
      prop: 'payAt',
      formatter: ({ cellValue }) => formatter.date(cellValue)
    })
  ]
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseDialog), {
    width: "880px",
    title: "发票金额",
    "model-value": true,
    "show-close": true,
    "close-on-press-escape": true,
    "close-on-click-modal": false,
    showFooter: false
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(BaseTextContent), null, {
        default: _withCtx(() => [
          _createVNode(_unref(XrkTable), {
            ref_key: "xrkTableRef",
            ref: xrkTableRef,
            getListAjax: getListAjax,
            searchConfig: searchConfig.value,
            tableConfig: tableConfig.value
          }, {
            tableBefore: _withCtx(() => [
              _createElementVNode("ul", _hoisted_1, [
                _createElementVNode("li", _hoisted_2, [
                  _createTextVNode(" 价税合计： "),
                  _createElementVNode("span", null, _toDisplayString(_unref(formatter).fen2yuan(invoiceAmount.value)) + "元", 1)
                ])
              ])
            ]),
            _: 1
          }, 8, ["searchConfig", "tableConfig"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})